// @flow
/* eslint-disable camelcase */
import React from 'react';
import get from 'lodash/get';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import type { IntlShape } from 'react-intl';
import { trackEvent } from '../../../../tracking/actions';
import * as TrackEvents from '../../../../tracking/events';
import { clearSearchParameters } from '../../../../utils/searchParameters';
import { setSearchParams as setSearchParamsAction } from '../../../actions';
import {
  facetsSelector,
  searchParametersSelector,
  showingFiltersSelector,
  countSelector,
  isFetchingSelector,
} from '../../../selectors';
import { activateUserFilterInteraction } from './actions';
import { sortToObject } from './utils/sortToObject';
import { getFiltersValues } from './utils/getFiltersValues';
import { getCurrentFiltersFromNewSearchParams } from './utils/getCurrentFiltersFromNewParams';
import FiltersFromVertical from './FiltersFromVertical/component';
import { configSelector } from '~/common/selectors/config';

type Props = {
  facets: Object,
  searchParameters: Object,
  hideFilters: Function,
  showing: boolean,
  count: number,
  isFetching: boolean,
  intl: IntlShape,
  config: Object,
  trackEvent: Function,
  activateUserFilterInteraction: Function,
  setSearchParams: Function,
  animated: boolean,
};

class Filters extends React.Component<Props> {
  onFiltersChanged(filters: Object) {
    this.props.activateUserFilterInteraction();
    let newSearchParameters = {
      ...this.props.searchParameters,
      page: 1,
      routeName: 'serp_search',
      pageName: 'serp',
      isSeoUrl: false,
    };
    const currentFilters = getCurrentFiltersFromNewSearchParams(filters, newSearchParameters);

    newSearchParameters = { ...newSearchParameters, filters: currentFilters };

    this.props.setSearchParams(newSearchParameters, false);
  }

  onSortChanged(sort: string) {
    const newSearchParameters = {
      ...this.props.searchParameters,
      sort,
      routeName: 'serp_search',
      pageName: 'serp',
      isSeoUrl: false,
      page: 1,
    };

    this.props.trackEvent(TrackEvents.searchSortEvent(sort));

    this.props.setSearchParams(newSearchParameters, false);
  }

  onTypeChanged(type: number) {
    this.props.activateUserFilterInteraction();
    const newSearchParameters = {
      ...clearSearchParameters(this.props.searchParameters),
      type_id: type,
      routeName: 'serp_search',
      pageName: 'serp',
      isSeoUrl: false,
      page: 1,
    };
    this.props.setSearchParams(newSearchParameters, true);
  }

  setType = (event: Object) => this.onTypeChanged(parseInt(event.target.value, 10));

  setSort = (event: Object) => this.onSortChanged(event.target.value);

  setFilter = (event: Object, values: Object) => {
    let res;
    if (event) {
      const { target } = event;
      res = { [target.name]: target.type === 'checkbox' ? target.checked : target.value };
    } else {
      res = { ...values };
    }

    this.onFiltersChanged(res);
  };

  resetSearchParams = () => {
    this.props.trackEvent(TrackEvents.filtersResetEvent());
    this.props.activateUserFilterInteraction();
    const newSearchParameters = {
      ...clearSearchParameters(this.props.searchParameters),
      page: 1,
      routeName: 'serp_search',
      pageName: 'serp',
      isSeoUrl: false,
    };
    this.props.setSearchParams(newSearchParameters, false);
  };

  render() {
    const {
      hideFilters,
      showing,
      count,
      searchParameters,
      isFetching,
      config,
      animated,
      intl,
      facets,
    } = this.props;

    const filters = get(searchParameters, 'filters');
    const type_id = get(searchParameters, 'type_id');
    const sort = get(searchParameters, 'sort');
    const sortOptions = get(config, ['vertical', 'sort']);
    const verticalName = config.verticalName;

    const filtersValues = getFiltersValues(facets, searchParameters, intl, config);
    const sortValues = sortToObject(sortOptions, intl);

    return (
      <FiltersFromVertical
        verticalName={verticalName}
        filtersValues={filtersValues}
        sortValues={sortValues}
        hideFilters={hideFilters}
        showing={showing}
        count={count}
        onClearFilters={this.resetSearchParams}
        isFetching={isFetching}
        filters={filters}
        type_id={type_id}
        sort={sort}
        animated={animated}
        setFilter={this.setFilter}
        setType={this.setType}
        setSort={this.setSort}
      />
    );
  }
}

export function mapDispatchToProps(dispatch: Function) {
  return {
    activateUserFilterInteraction: () => dispatch(activateUserFilterInteraction()),
    setSearchParams: (searchParams: Object, hasTermChanged: boolean) =>
      dispatch(setSearchParamsAction(searchParams, hasTermChanged)),
    trackEvent: (event: Object) => dispatch(trackEvent(event)),
  };
}

export function mapStateToProps(state: Object) {
  return {
    facets: facetsSelector(state),
    searchParameters: searchParametersSelector(state),
    showing: showingFiltersSelector(state),
    count: countSelector(state),
    isFetching: isFetchingSelector(state),
    config: configSelector(state),
  };
}

const FiltersContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(Filters));

FiltersContainer.displayName = 'FiltersContainer';

export default FiltersContainer;

export const PureFilters = Filters;



// WEBPACK FOOTER //
// ./app/Serp/components/Filters/shared/container.js